import { createSlice } from '@reduxjs/toolkit';
import { getHrWidgetThunk, storeHrWidgetThunk } from './HRWidget.thunk';
import { HrWidgetDTO } from './HRWidget.type';
import { RootState } from '../../store';

const SLICE_NAME = 'hrWidget';

interface HrWidgetState {
  data: HrWidgetDTO | null;
  loading: boolean;
  error: string | null;
}

const initialState: HrWidgetState = {
  data: null,
  loading: false,
  error: null,
};

export const hrWidgetSlice = createSlice<HrWidgetState, any>({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getHrWidgetThunk.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHrWidgetThunk.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload;
      })
      .addCase(getHrWidgetThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Error while fetching HR widget';
      })
      .addCase(storeHrWidgetThunk.fulfilled, (state, { payload }) => {
        state.data = payload;
      });
  },
});

export const getInfoList = (state: RootState) => {
  return state.hrWidget.data?.info_list;
};

export const getHrVacanciesWidget = (state: RootState) => {
  return state.hrWidget.data?.hr_vacancies_widget;
};

export const getInfoRegion = (state: RootState) => {
  return state.hrWidget.data?.info_region?.[0];
};

export default hrWidgetSlice.reducer;

